import { useTranslate } from "@/hooks";

import { TranslationsProps } from "./type";

const Translations = ({ text }: TranslationsProps) => {
  const translate = useTranslate();

  return <>{`${translate(text)}`}</>;
};

export default Translations;
